declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

const pushedEvents = new Set<string>()

export function dataLayer(): Array<Record<string, unknown>> {
  window.dataLayer = window.dataLayer || []
  return window.dataLayer
}

export function pushEvent(event: string, params: Record<string, unknown> = {}): void {
  dataLayer().push({
    event,
    ...params,
  })
}

export function pushOnce(key: string, callback: () => void): void {
  if (pushedEvents.has(key)) return

  pushedEvents.add(key)
  callback()
}
